import { sensorRadarCoverageLayer } from '@components/map/layers/radarCoverage/radarCoverage.layer';
import { useMapContext } from '@components/map/MapContext';
import { createSensorLayerErrorToast } from '@components/ui/toaster/toaster';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectRadarCoverageFeatures } from '@redux/mapDisplay/mapDisplay.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { ErrorBoundary } from 'react-error-boundary';
import { Layer, Source } from 'react-map-gl/mapbox';

import { MapIdEnum, SourceNameEnum } from '@/types/map.types';

function RadarCoverageLayerContent() {
  const radarCoverageFeatures = useSelectorWithReplayMode(selectRadarCoverageFeatures);

  if (!isFeatureCollection(radarCoverageFeatures)) return null;

  return (
    <Source id={SourceNameEnum.RADARS} type="geojson" data={radarCoverageFeatures}>
      <Layer {...sensorRadarCoverageLayer} />
    </Source>
  );
}

export default function RadarCoverageLayer() {
  const { mapId } = useMapContext();
  return mapId === MapIdEnum.REPLAY ? (
    <ErrorBoundary fallback={<></>} onError={() => createSensorLayerErrorToast(SourceNameEnum.RADARS)}>
      <RadarCoverageLayerContent />
    </ErrorBoundary>
  ) : (
    <RadarCoverageLayerContent />
  );
}
